import { coverSrc } from "@/lib/api";

export default function Avatar({ user, size = 40 }) {
  const src = coverSrc(user?.avatar);
  if (src) return <img src={src} alt={user?.name} className="shrink-0 rounded-full object-cover" style={{ width: size, height: size }} />;
  return (
    <div className="flex shrink-0 items-center justify-center rounded-full bg-primary font-bold text-primary-foreground" style={{ width: size, height: size, fontSize: size * 0.4 }}>
      {user?.name?.[0]?.toUpperCase() || "?"}
    </div>
  );
}
